"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const prizeInputs = [
  {
    name: "prize_uuid",
    friendlyName: "OL Prize uuid",
    type: "string",
    required: true,
  },
  {
    name: "images",
    type: "list",
    subFields: [
      {
        name: "mobile",
        type: "file",
        allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
        required: true,
      },
      {
        name: "tablet",
        type: "file",
        allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
        required: true,
      },
      {
        name: "desktop",
        type: "file",
        allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
        required: true,
      },
      {
        name: "alt",
        type: "string",
        required: true,
      },
    ],
    required: true,
  },
  {
    name: "logoUrl",
    friendlyName: "RedeemPrizes Dialog Logo",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
  },
  {
    name: "logoAlt",
    friendlyName: "Alt Text for Logo",
    type: "string",
    defaultValue: "Logo Alt",
  },
  {
    name: "prizesPageUrl",
    friendlyName: "Prizes Page URL",
    type: "string",
    defaultValue: "#",
  },
  {
    name: "earnPointsCtaUrl",
    friendlyName: "Earn Points CTA URL",
    type: "string",
    defaultValue: "#",
    required: true,
  },
  {
    name: "discoverButtonUrl",
    friendlyName: "Discover CTA URL",
    type: "string",
    defaultValue: "#",
    required: true,
  },
  {
    name: "loginButtonUrl",
    friendlyName: "Login CTA URL",
    type: "string",
    defaultValue: "#",
    required: true,
  },
  {
    name: "newOfferDays",
    friendlyName: "New Offer Days",
    helperText: "How many days old prize is considered new",
    type: "number",
    defaultValue: 7,
    required: true,
  },
  {
    name: "isLotteryAddressRequirementDisabled",
    friendlyName: "Disable address requirement for lotteries",
    type: "boolean",
    defaultValue: false,
    helperText: "When enabled, lottery prizes will not require a delivery address. Physical prizes always require one.",
  },
  {
    name: "quantityAriaLabel",
    type: "string",
    friendlyName: "Quantity input aria label",
    defaultValue: "Quantity",
  },
  {
    name: "increaseAriaLabel",
    type: "string",
    friendlyName: "Increase quantity aria label",
    defaultValue: "Increase quantity",
  },
  {
    name: "decreaseAriaLabel",
    type: "string",
    friendlyName: "Decrease quantity aria label",
    defaultValue: "Decrease quantity",
  },
] as const satisfies Inputs;

export const PrizeComponent: RegisteredComponent = {
  name: "Prize",
  component: dynamic(async () => withValidation(prizeInputs, (await import("./Prize")).Prize, "Prize")),
  inputs: prizeInputs,
  requiresParent: {
    query: {
      "component.name": { $in: ["LoyaltyWrapper"] },
    },
    message: "'Prize' component can only be added inside a 'LoyaltyWrapper'",
  },
};
